import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { MonthlyRecap } from '../../models/monthly-recap.model';
import { FinancialUtilityService } from '../../services/utility/financial-utility.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-trade-monthly-recap-table',
  standalone: true,
  imports: [
    CommonModule, 
    TableModule, 
    TagModule, 
    TooltipModule
  ],
  templateUrl: './trade-monthly-recap-table.html'
})
export class TradeMonthlyRecapTableComponent extends AbstractComponent {
  recapList = input.required<MonthlyRecap[]>();
  headerName = input<string>();
  showHeader = input<boolean>();
  addRowTotal = input<boolean>();
  transformType = input<string>();
  lastColName = input<string>("TOTALE");
  enableDetail = input<boolean>(false);
  onDetail = output<MonthlyRecap>();

  recapListWithTotal = computed(() => {
    let list = this.recapList();
    if (this.addRowTotal() && list) {
      let total = FinancialUtilityService.getTotal(list);
      console.log(total)
      total.shortDescription = 'TOTALE';
      total.isBoldRow = true;
      return [...list, total];
    }
    return list || [];
  });
    
  public transformValue(value: number){
    if(!value || !Number.isFinite(value)) value=0;
    if(this.transformType()=='currency'){
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    }else if(this.transformType()=='percentage'){
      return value.toFixed(2)+'%';
    }else{
      return value;
    }

  }

  public openDetail(monthClicked: number, m: MonthlyRecap){
    m.monthClicked = monthClicked;
    this.onDetail.emit(m);
      
  }

public readonly months = [
  { id: 1, label: 'Gennaio', key: 'jan' },
  { id: 2, label: 'Febbraio', key: 'feb' },
  { id: 3, label: 'Marzo', key: 'mar' },
  { id: 4, label: 'Aprile', key: 'apr' },
  { id: 5, label: 'Maggio', key: 'may' },
  { id: 6, label: 'Giugno', key: 'jun' },
  { id: 7, label: 'Luglio', key: 'jul' },
  { id: 8, label: 'Agosto', key: 'aug' },
  { id: 9, label: 'Settembre', key: 'sep' },
  { id: 10, label: 'Ottobre', key: 'oct' },
  { id: 11, label: 'Novembre', key: 'nov' },
  { id: 12, label: 'Dicembre', key: 'dic' }
];

}
